import React, { useMemo } from "react";
import { Box, Paper, Typography } from "@mui/material";
import OpsConsole from "./OpsConsole";
import { getJwt } from "../../api_middleware";

/**
 * OpsConsoleTab
 * Wrapper that wires auth + base URLs for the Ops Console page.
 *
 * Auth requirements (per backend):
 *  - WebSocket: ws "+ ?token=<JWT>"
 *  - HTTP complete: Authorization: Bearer <JWT>
 */
const OpsConsoleTab: React.FC = () => {
  const HTTP_API_BASE = (process.env.REACT_APP_BASE_BACKEND_URL!).replace(/\/$/, "");
  const WS_API_BASE = (() => {
    try {
      const u = new URL(HTTP_API_BASE);
      const scheme = u.protocol === "https:" ? "wss:" : "ws:";
      return `${scheme}//${u.host}`;
    } catch {
      return HTTP_API_BASE.replace(/^https?/, (m) => (m === "https" ? "wss" : "ws"));
    }
  })();

  const httpBaseUrl = useMemo(() => `${HTTP_API_BASE}/v1/admin/ops`, [HTTP_API_BASE]);
  const wsBaseUrl = useMemo(() => `${WS_API_BASE}/v1/admin/ops`, [WS_API_BASE]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="h5">Ops Console</Typography>
      <Paper sx={{ p: 2 }}>
        <OpsConsole httpBaseUrl={httpBaseUrl} wsBaseUrl={wsBaseUrl} getJwt={getJwt} />
      </Paper>
    </Box>
  );
};

export default OpsConsoleTab;